import script from "./BaseFeedback.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseFeedback.vue?vue&type=script&lang=ts&setup=true"

import "./BaseFeedback.vue?vue&type=style&index=0&id=6d367745&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d367745"]])

export default __exports__